export const classesMap = (styles: Record<string, string>) => ({
  custom: {
    paper: styles.estimatePaper,
    paperScrollBody: styles.customPaperScrollBody,
    scrollBody: styles.backdropBodyNonScrollbable,
  },
  estimate: {
    paper: styles.estimatePaper,
    paperScrollBody: styles.estimatePaperScrollBody,
    scrollBody: styles.backdropBodyNonScrollbable,
  },
  schedule: {
    paper: styles.paperDefault,
  },
  basic: {
    paper: styles.paperDefault,
  },
  withSeparator: {
    paper: styles.paperDefault,
  },
  fullScreen: {
    paper: styles.fullScreenPaper,
  },
});
